import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-editor",
  "use": "icon-editor-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-editor\"><path d=\"M707.29 382.68L497.14 170.56 143.61 520.81l210.14 212.12 353.54-350.25z m106.06-105.07L603.2 65.49l-70.7 70.05 210.14 212.12 70.71-70.05zM318.4 767.95L108.26 555.84 71.89 801.99l246.51-34.04zM64.03 859.68v99.53h895.78v-99.53H64.03z\" p-id=\"11435\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol